module.exports = __webpack_public_path__ + "static/media/L-3.bfc553c2.svg";